import { LitElement, html, css } from 'lit';
import { accessibility, formStyles } from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
import { editIcon, addIcon, deleteIcon, arrowBack } from '../../utilities/icons';
import { cache } from 'lit/directives/cache.js';
import { ContextConsumer } from '@lit/context';
import { organisationContext } from '../../utilities/context';
import { validateForm, decodeEntities } from '../../utilities/formsUtilities';
import { getRole, getInviteStatus } from '../../utilities/orgUtilities';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInOrganisationUserForm extends LitElement {
    static properties = {
        currentOrg: { type: String, reflect: true },
        name: { type: String },
        _showInviteForm: { state: true, type: Boolean },
        _showPrimaryAdminForm: { state: true, type: Boolean },
        _showAdminForm: { state: true, type: String },
        _loading: { state: true, type: Boolean },
        _userData: { state: true, type: Array },
        _role: { state: true, type: String },
    };
    constructor() {
        super();
    }
    get _form() {
        return this.shadowRoot.querySelector('form');
    }
    get _modal() {
        return this.shadowRoot.querySelector('dialog');
    }
    async connectedCallback() {
        super.connectedCallback();
        this._organisationData = new ContextConsumer(this, { context: organisationContext, subscribe: true });
        this.organisationData = this._organisationData?.value;
        ({ currentOrg: this.currentOrg, name: this.name, restUrl: this.restUrl, organisations: this.organisations, action: this.action, nonce: this.nonce, user: this.currentUser } = this.organisationData);
        this.organisation = this._getOrganisationById(this.currentOrg);
        this.eventManager = new EventManager(this);
        this._showInviteForm = false;
        this._showPrimaryAdminForm = false;
        this._showAdminForm = '';
        this._loading = true;
        if (this.organisation.hasOwnProperty('users')) {
            this._userData = this.organisation.users;
            this._loading = false;
        }
        else {
            await this._fetchUsers();
        }
        this._role = this._userData.users.find(user => user.id === this.currentUser.id)?.role;
    }
    updated(changedProperties) {
        if (changedProperties.has('_showPrimaryAdminForm') || changedProperties.has('_showInviteForm') || changedProperties.has('_showAdminForm')) {
            if (this._showPrimaryAdminForm || this.showInviteForm || this._showAdminForm) {
                this.renderRoot.querySelector('input, select')?.focus();
            }
            else {
                this.renderRoot.querySelector('a,button')?.focus();
            }
        }
    }
    render() {
        let main = '';
        if (this._loading) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else if (this._showPrimaryAdminForm) {
            let admins = this._userData.users.filter(user => user.role == 'MANAGER');
            if (!admins.length) {
                main = html `\n                <div class="bg margin-top">\n                    <div class="message"><p>Mae angen i Weinyddwr arall yn eich sefydliad wneud hyn</p></div>\n                    <button class="cancel" @click=${this._handlePrimaryAdminClick}><span aria-hidden="true">${deleteIcon}</span>Canslo</button>\n                </div>\n                `;
            }
            else {
                let adminHtml = admins.map(user => {
                    return html `<option value="${user.id}__${user.userJobTitle}">${user.firstName} ${user.lastName}</option>`;
                });
                main = html `\n                <form @submit=${this._handleModal}>\n                    <h3>Newid prif weinyddwr ar gyfer ${this.organisation.name}</h3>\n                    <div class="message notice" aria-live="polite"></div>\n                    <div class="bg">\n                        <div class="input-group">\n                            <label for="newAdmin">Dewis gweinyddwr newydd</label>\n                            <select name="newAdmin" id="newAdmin">\n                                ${adminHtml}\n                            </select>\n                            <input type="hidden" name="currentAdmin" value="${this._userData.users.find(user => user.id === this.currentUser.id)?.id}__${this._userData.users.find(user => user.id === this.currentUser.id)?.userJobTitle}" />\n                            <input type="hidden" name="org_id" value="${this.currentOrg}" />\n                            <input type="hidden" name="action" value="${this.action}-change-primary-admin" />\n                        </div>\n                        <div class="button-group">\n                            <button class="cancel" @click=${this._handlePrimaryAdminClick}><span aria-hidden="true">${deleteIcon}</span>Canslo</button>\n                            <input type="submit" value="Dewis prif weinyddwr" />\n                        </div>\n                    </div>\n                </form>\n                <dialog>\n                    <button autofocus @click=${this._handlePrimaryAdminClick}>Cau</button>\n                    <p>\n                        Ydych chi\u2019n si\u0175r eich bod am newid y prif weinyddwr? Byddwch yn cael eich allgofnodi er mwyn rhoi\u2019r newid ar waith\n                    </p>\n                    <button @click=${this._handlePrimaryAdminChange}>Ydw, rwy\u2019n si\u0175r</button>\n                </dialog>\n            `;
            }
        }
        else if (this._showInviteForm) {
            const adminExists = this._hasPrimaryAdmin();
            main = html `\n                    <form @submit=${this._handleInvite}>\n                        <h3>Manylion defnyddiwr</h3>\n                        <div class="message notice" aria-live="polite"></div>\n                        <div class="bg">\n                            <div class="input-group">\n                                <label for="email">Cyfeiriad e-bost*</label>\n                                <input type="email" name="email" id="email" aria-required="true" />\n                            </div>\n                            <fieldset>\n                                <legend>Dewis eu r\u00F4l</legend>\n\n                                ${!adminExists ? html `\n                                    <div class="input-group">\n                                        <input type="radio" name="role" id="admin" value="ADMIN"/>\n                                        <label for="admin">${getRole('ADMIN')}</label>\n                                    </div>\n                                ` : ''}\n\n                                <div class="input-group">\n                                    <input type="radio" name="role" id="manager" value="MANAGER"/>\n                                    <label for="manager">${getRole('MANAGER')}</label>\n                                </div>\n\n                                <div class="input-group">\n                                    <input type="radio" name="role" id="cultural-manager" value="CULTURAL_MANAGER" checked/>\n                                    <label for="cultural-manager">${getRole('CULTURAL_MANAGER')}</label>\n                                </div>\n\n                                ${adminExists ? html `\n                                    <p class="notice">Mae gan y sefydliad hwn brif weinyddwr yn barod. Dim ond un a ganiateir.</p>\n                                ` : ''}\n                            </fieldset>\n                            <input type="hidden" name="org_id" value="${this.currentOrg}" />\n                            <input type="hidden" name="action" value="${this.action}-invite-user" />\n                        </div>\n                        <div class="button-group">\n                            <button class="cancel" @click=${this._handleInviteClick}><span aria-hidden="true">${deleteIcon}</span>Canslo</button>\n                            <input type="submit" value="Anfon gwahoddiad" />\n                        </div>\n                    </form>\n                `;
        }
        else if (this._showAdminForm) {
            let user = this._userData.users.find((user) => user.id == this._showAdminForm);
            let currentRole = user.role;
            let roles = [{ type: 'MANAGER', label: getRole('MANAGER') }, { type: 'TEAM_MEMBER', label: getRole('TEAM_MEMBER') }];
            if (!this._hasPrimaryAdmin(user.id)) {
                roles.unshift({ type: 'ADMIN', label: getRole('ADMIN') });
            }
            main = html `\n                <form @submit=${this._handleSubmit}>\n                    <h3>Newid r\u00F4l ar gyfer ${user.firstName} ${user.lastName}</h3>\n                    <div class="message notice" aria-live="polite"></div>\n                    <div class="bg">\n                        <div class="input-group">\n                            <p>R\u00F4l bresennol: ${getRole(currentRole)}</p>\n                            <label for="role">Dewis r\u00F4l newydd</label>\n                            <select name="role" id="role">\n                                ${roles.map((role) => {
                if (role.type !== currentRole) {
                    return html `\n                                            <option value="${role.type}">${role.label}</option>\n                                        `;
                }
                else {
                    return '';
                }
            })}\n                            </select>\n                            <input type="hidden" name="org_id" value="${this.currentOrg}" />\n                            <input type="hidden" name="user" value="${this._showAdminForm}" />\n                            <input type="hidden" name="jobTitle" value="${user.userJobTitle}" />\n                            <input type="hidden" name="action" value="${this.action}-change-role" />\n                        </div>\n                        <div class="button-group">\n                            <button class="cancel" @click=${this._handleAdminClick}><span aria-hidden="true">${deleteIcon}</span>Canslo</button>\n                            <input type="submit" value="Newid r\u00F4l" />\n                        </div>\n                    </div>\n                </form>\n            `;
        }
        else {
            this._userData.users.sort((a, b) => {
                if (a.id == this.currentUser.id) {
                    return -1;
                }
                if (a.role == 'MANAGER') {
                    return -1;
                }
                if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
                    return -1;
                }
                if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
            let primaryAdmin = this._userData.users.find((user) => user.role == 'ADMIN');
            let primaryAdminHtml = '';
            if (primaryAdmin) {
                let button = '';
                if (this.currentUser.id == primaryAdmin.id) {
                    button = html `<button @click=${this._handlePrimaryAdminClick} data-id="${primaryAdmin.id}"><span aria-hidden="true">${editIcon}</span>Dewis prif weinyddwr</button>`;
                }
                primaryAdminHtml = html `\n                    <ul title="Prif Weinyddwr">\n                        <li>\n                            <div class="content">\n                                <p><strong>Prif weinyddwr</strong></p>\n                                <p>${primaryAdmin.firstName} ${primaryAdmin.lastName}</p>\n                                <p><strong>E-bost</strong></p>\n                                <p><a href="mailto:${primaryAdmin.email}">${primaryAdmin.email}</a></p>\n                            </div>\n                            <div class="content"></div>\n                            ${button}\n                        </li>\n                    </ul>\n                `;
            }
            let inviteUsers = '';
            if (this._role == 'MANAGER' || this._role == 'ADMIN') {
                inviteUsers = html `<button @click=${this._handleInviteClick}><span aria-hidden="true">${addIcon}</span>Gwahodd defnyddiwr newydd</button>`;
            }
            main = html `\n                <h3>Gweinyddwyr ar gyfrif ${decodeEntities(this.organisation.name)}</h3>\n                ${primaryAdminHtml}\n                <ul title="Gweinyddwyr">\n                    ${this._userData.users.map((user) => {
                if (user.id == this.currentUser.id) {
                    return html `\n                                <li>\n                                    <div class="content">\n                                        <p><strong>Enw</strong></p>\n                                        <p>${user.firstName} ${user.lastName}</p>\n                                        <p><strong>E-bost</strong></p>\n                                        <p><a href="mailto:${user.email}">${user.email}</a></p>\n                                    </div>\n                                    <div class="content">\n                                        <p><strong>R\u00F4l defnyddiwr</strong></p>\n                                        <p>${getRole(user.role)} (You)</p>\n                                    </div>\n                                </li>\n                            `;
                }
                let button = '';
                let removeButton = '';
                if (this._role == 'MANAGER' || this._role == 'ADMIN') {
                    if (user.role !== 'ADMIN') {
                        button = html `<button @click=${this._handleAdminClick} data-id="${user.id}"><span aria-hidden="true">${editIcon}</span>Golygu caniat\u00E2d</button>`;
                        removeButton = html `<button @click=${this._handleRemoveUserClick} data-id="${user.id}"><span aria-hidden="true">${deleteIcon}</span>Tynnu defnyddiwr</button>`;
                    }
                }
                return html `\n                            <li>\n                                <div class="content">\n                                    <p><strong>Enw</strong></p>\n                                    <p>${user.firstName} ${user.lastName}</p>\n                                    <p><strong>E-bost</strong></p>\n                                    <p><a href="mailto:${user.email}">${user.email}</a></p>\n                                </div>\n                                <div class="content">\n                                    <p><strong>R\u00F4l defnyddiwr</strong></p>\n                                    <p>${getRole(user.role)}</p>\n                                </div>\n                                <div class="buttons">\n                                    ${button}${removeButton}\n                                </div>\n                            </li>\n                        `;
            })}\n                    ${this._userData.invitedUsers.map((user) => {
                let removeButton = '';
                let reinviteButton = '';
                if (this._role == 'MANAGER' || this._role == 'ADMIN') {
                    // removeButton = html`<button @click=${this._handleRemoveUserClick} data-id="${user.id}"><span aria-hidden="true">${deleteIcon}</span>${msg(`Remove user`)}</button>`;
                    removeButton = '';
                    reinviteButton = html `<button class="resend_invite" @click=${this._handleReinviteUserClick} data-id="${user.email}" data-role="${user.role}"><span aria-hidden="true">${arrowBack}</span><span class="resend">Anfon gwahoddiad eto</span><span class="resent">Invite sent</span></button>`;
                }
                return html `\n                            <li>\n                                <div class="content">\n                                    <p><strong>Enw</strong></p>\n                                    <p>${user.firstName} ${user.lastName}</p>\n                                    <p><strong>E-bost</strong></p>\n                                    <p><a href="mailto:${user.email}">${user.email}</a></p>\n                                </div>\n                                <div class="content">\n                                    <p><strong>R\u00F4l defnyddiwr</strong></p>\n                                    <p>${getRole(user.role)}</p>\n                                </div>\n                                <div class="buttons invite-status ${user.status?.toLowerCase()}">${getInviteStatus(user.status)}${removeButton}${reinviteButton}</div>\n                            </li>\n                        `;
            })}\n\n                   ${inviteUsers}\n                </ul>\n            `;
        }
        return html `<div aria-live=polite>${cache(main)}</div>`;
    }
    _handlePrimaryAdminClick(e) {
        e.preventDefault();
        this._showPrimaryAdminForm = !this._showPrimaryAdminForm;
    }
    _handleAdminClick(e) {
        e.preventDefault();
        if (!this._showAdminForm) {
            this._showAdminForm = e.currentTarget.dataset.id;
        }
        else {
            this._showAdminForm = '';
        }
    }
    /* _handleAdminChange(e){
        e.preventDefault();
        this._showAdminForm = e.currentTarget.dataset.id;
    }
 */
    _handleInviteClick(e) {
        e.preventDefault();
        this._showInviteForm = !this._showInviteForm;
    }
    _handleInvite(e) {
        e.preventDefault();
        this._handleSubmit(e);
    }
    _handleModal(e) {
        e.preventDefault();
        if (this._modal.open) {
            this._modal.close();
        }
        else {
            this._modal.showModal();
        }
    }
    _handlePrimaryAdminChange(e) {
        e.preventDefault();
        this._modal.close();
        this._handleSubmit(e);
    }
    _handleRemoveUserClick(e) {
        e.preventDefault();
        let userId = e.currentTarget.dataset.id;
        let user = this._userData.users.find(user => user.id === userId);
        let text = user ? `Ydych chi'n si\u0175r eich bod am dynnu ${user.firstName} ${user.lastName}?` : `Ydych chi'n si\u0175r eich bod am dynnu'r defnyddiwr hwn?`;
        if (window.confirm(text)) {
            this._removeUser(userId);
        }
    }
    async _removeUser(userId) {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-remove-user&nonce=${this.nonce}`;
        let body = { user_id: userId, org_id: this.currentOrg, action: this.action + '-remove-user' };
        let response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'AllIn-Nonce': this.nonce,
            },
            body: JSON.stringify(body)
        });
        if (response.status === 403) {
            handle403s();
            return;
        }
        response = await response.json();
        if (response.ok) {
            this._userData.users = this._userData.users.filter(user => user.id !== userId);
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation) });
        }
        else {
            console.error('Error removing user:', response.error);
        }
    }
    async _handleReinviteUserClick(e) {
        e.preventDefault();
        let node = e.currentTarget;
        console.log(node, e.currentTarget, e);
        node.classList.add('loading');
        node.disabled = true;
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: JSON.stringify({
                    email: e.currentTarget.dataset.id,
                    role: e.currentTarget.dataset.role,
                    org_id: this.currentOrg,
                    action: this.action + '-invite-user'
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            console.log('Reinvite response:', response);
            if (response.ok) {
                console.log(e.currentTarget, e);
                node.classList.remove('loading');
                node.classList.add('invited');
            }
        }
        catch (error) {
            console.error('Error:', error);
            e.currentTarget.classList.remove('loading');
            e.currentTarget.disabled = false;
        }
        this._fetchUsers();
    }
    async _handleSubmit(e) {
        e.preventDefault();
        this._modal?.close();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('input[type="submit"]');
        let valid = validateForm(this._form, formResponse);
        if (!valid)
            return;
        let formData = new FormData(this._form);
        //Prevents someone manually editing the HTML to submit another ADMIN
        if (formData.get('role') === 'ADMIN' && this._hasPrimaryAdmin()) {
            formResponse.innerHTML = `Mae gan y sefydliad hwn brif weinyddwr yn barod.`;
            formResponse.classList.add('error');
            return;
        }
        let jsonFormData = JSON.stringify(Object.fromEntries(formData));
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: jsonFormData,
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            // check status ok before parsing json
            if (!response.ok) {
                throw new Error(`Server returned ${response.status}`);
            }
            // parse response json into a new variable so as to keep the old response object - with same properties and methods
            let data = await response.json(); // then replace response with data on its references below
            //response = await response.json()
            if (data.ok) {
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                if (data.redirect) {
                    window.location.href = data.redirect;
                }
                this._form.reset();
                submitButton.disabled = false;
                this._showInviteForm = false;
                this._showPrimaryAdminForm = false;
                this.loading = true;
                this._showInviteForm = false;
                this._showPrimaryAdminForm = false;
                this._showAdminForm = '';
                this._fetchUsers();
            }
            else {
                formResponse.innerHTML = 'Something went wrong';
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                this._form.reset();
                submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
            // inform the user
            formResponse.innerHTML = 'An unexpected error occurred. Please try again.';
            formResponse.classList.add('error');
            // Reset form state
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
            submitButton.disabled = false;
        }
        ;
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    // check if organisation already has Primary Admin
    _hasPrimaryAdmin(excludeUserId = null) {
        return this._userData?.users?.some(user => user.role === 'ADMIN' && user.id !== excludeUserId);
    }
    async _fetchUsers() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-users&nonce=${this.nonce}`;
        let response = await fetch(url, {
            headers: {
                'AllIn-Nonce': this.nonce,
            }
        });
        if (response.status === 403) {
            handle403s();
            return;
        }
        response = await response.json();
        this._loading = false;
        this._userData = response.users;
        this.organisation.users = response.users;
        this.eventManager.emit(`allin-organisation-${this.name}-update`, { organisation: JSON.stringify(this.organisation), panel: 'staff' });
    }
    static styles = [
        accessibility,
        formStyles,
        css `
         h3{
            color:var(--allin-heading-color,#472961);
        }

        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }

        .small{
            font-size:0.875rem;
        }

        form{
            gap:0;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .buttons{
            display:flex;
            flex-direction:column;
            gap:0.5rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }

        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }

        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }

        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:40%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:60%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        ::backdrop {
            background-color: rgba(0, 0, 0, 0.5);
        }

        dialog[open] {
            opacity: 1;
        }

        dialog {
            opacity:0;
            transition:opacity var(--transition) ease;
        }

        @starting-style{
            dialog[open]{
                opacity:0;
            }
        }

        ul{
            list-style:none;
            padding:0;
            margin:0;
            background-color:var(--allin-white-color,#fff);
            border:1px solid var(--allin-border-color,#000);
            padding:2rem;
           
        }

        ul li{
            display:grid;
            grid-template-columns:4fr 3fr 3fr;
            font-size:0.9rem;
        }

        ul+ul{
            margin-top:2rem;
        }

        .content p{
            margin-bottom:0.5rem;
        }

        .content p:has(>strong){
            margin-bottom:0.1rem;
        }

        ul li + li{
            border-top:1px solid var(--allin-border-color,#000);
            padding-top:1.5rem;
            margin-top:1rem
        }

        ul button,.cancel{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            height:fit-content;
            padding:0;
            font-weight:700;
            text-decoration:underline;
            font-size:0.9rem;
            display:flex;
            gap:0.5rem;
            align-items:center;
            padding:0;
            text-align:left;
        }

        ul button span:not(.resend, .resent), .cancel span{
            display:flex;
            align-items:center;
            width:1.2rem;
        }

        ul button svg, .cancel svg{
            transition:transform var(--transition) ease;
            width:1.2rem;
        }

        ul button:hover, .cancel:hover{
            text-decoration-thickness:2px;
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            font-weight:700;
        }

        ul button:hover svg, .cancel:hover svg{
            transform:rotate(5deg);
        }

        li:has(+button){
            border-bottom:1px solid var(--allin-border-color,#000);
            padding-bottom:1.5rem;
            margin-bottom:1rem
        }

        li a{
            color:var(--allin-text-color,#000);
            word-break:break-all;
            
        }

        li a:hover{
            text-decoration-thickness:1.2px;
        }

        li>*nth-child(2){
           padding:0 1rem;
        }

        li>*:nth-child(3){
            justify-self:end;
        }
        .invite-status{
            font-weight:700;
        }

        .invite-status.invited{
            color:var(--allin-disable-color,#707070);
        }

        .message:empty{
            display:none;
        }
        legend{
            font-size:1rem;
            margin-bottom:0.5rem;
            color:var(--allin-text-color,#000);
        }

        .button-group{
            margin-top:0;
            align-items:center;
        }

        .margin-top{
            margin-top:2rem;
        }
        .input-group:has(>input[type=checkbox],>input[type=radio]){
            justify-content:flex-start;
        }
        button.loading, button[disabled]{
            pointer-events:none;
            opacity:0.7;
            position:relative;    
        }

        button.resend_invite .resent{
            display:none;
        }

        button.resend_invite.invited svg{
            display:none;
        }
        
        button.resend_invite.invited .resend{
            display:none;
        }

        button.resend_invite.invited .resent{
            display:inline;
        }

        button.loading::after{
            content:'';
            display:block;
            position:absolute;
            left:100%;
            width:1rem;
            height:1rem;
            border: 2px solid var(--allin-highlight-color,#472961);
            border-top: 2px solid transparent;
            border-radius: 50%;
            margin-left:0.5rem;
            animation: rotate var(--transition) linear infinite;
        }
        @keyframes rotate {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);  
            }
        }
        `
    ];
}
